import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import articleIcon from "@phosphor-icons/core/regular/article.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const informationalText: Tool = {
    urlSlug: "informational-text",
    configName: "teacher-tool-informational-text",
    title: () => t`Informational text`,
    description: () => t`Create informational text for a variety of topics`,
    categories: [ToolCategories.Create, ToolCategories.Differentiate],
    icon: articleIcon,
    color: color.fadedGreen24,
    layout: Layout.Coeditor,
    reportingLabelId: "informational-text",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () =>
                t`The text will be approximately leveled for this grade level.`,
            inputKind: "SINGLE_SELECT",
            label: () => t`Grade level`,
            required: true,
            selectOptions: [
                {
                    label: () => t`1st grade`,
                    value: "1st grade",
                },
                {
                    label: () => t`2nd grade`,
                    value: "2nd grade",
                },
                {
                    label: () => t`3rd grade`,
                    value: "3rd grade",
                },
                {
                    label: () => t`4th grade`,
                    value: "4th grade",
                },
                {
                    label: () => t`5th grade`,
                    value: "5th grade",
                },
                {
                    label: () => t`6th grade`,
                    value: "6th grade",
                },
                {
                    label: () => t`7th grade`,
                    value: "7th grade",
                },
                {
                    label: () => t`8th grade`,
                    value: "8th grade",
                },
                {
                    label: () => t`9th grade`,
                    value: "9th grade",
                },
                {
                    label: () => t`10th grade`,
                    value: "10th grade",
                },
                {
                    label: () => t`11th grade`,
                    value: "11th grade",
                },
                {
                    label: () => t`12th grade`,
                    value: "12th grade",
                },
                {
                    label: () => t`College`,
                    value: "College",
                },
            ],
            variableName: "gradeLevel",
        },
        {
            description: () => t`e.g., the fall of Rome`,
            inputKind: "TEXT_BOX",
            label: () => t`Topic`,
            required: true,
            variableName: "topic",
        },
        {
            description: () => t`e.g., focus on the role of Constantine I`,
            inputKind: "TEXT_BOX",
            label: () => t`Additional instructions`,
            variableName: "instructions",
        },
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Text length`,
            required: true,
            selectOptions: [
                {
                    label: () => t`100 words`,
                    value: "100 words",
                },
                {
                    label: () => t`300 words`,
                    value: "300 words",
                },
                {
                    label: () => t`750 words`,
                    value: "750 words",
                },
            ],
            variableName: "textLength",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
